export default {
    title: 'SMS',
    appointmentMessageLabel: 'Message de rappel de rendez-vous',
    unsubscribeMessageLabel: 'Message de désabonnement',
    unsubscribeInfo:
        'Le message de désabonnement est envoyé avec les messages automatisés et les campagnes SMS.',
    appendConfirmation: 'Ajouter le message de confirmation à ce message',
    enableForLabel:
        'Activer la confirmation de rendez-vous pour toutes les nouvelles réservations de rendez-vous:',
    enableForSales: 'Pour les leads de vente',
    enableForService: 'Pour les leads de service',
    customizeMessages: 'Personnaliser les messages',
    disableOptOutMessage: 'Désactiver le message de désabonnement pour les SMS automatisés',
    leaveEmptyForDefault: 'Laisser vide pour utiliser le message par défaut',
    confirmationWillBeAppended: 'Le message de confirmation suivant sera ajouté',
};
